module.exports = __webpack_public_path__ + "static/cover3-36ad4aebbd0079f94cb8b99971b5208f.png";